import {isNil} from 'ramda';

import {SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';

import {Nullish} from 'shared/web';

import {LeasingCellCoordinates} from '../types/LeasingCellCoordinates';
import {findLeasingCell} from '../utils/findLeasingCell';
import {isActiveLeasingCell} from '../utils/isActiveLeasingCell';
import {removeLeasingCell} from '../utils/removeLeasingCell';
import {updateLeasingCell} from '../utils/updateLeasingCell';
import {LeasingCellDialog} from './LeasingCellDialog';

interface LeasingCellEditorDialogProps {
  cellCoordinates: LeasingCellCoordinates | Nullish;
  vehicleLeasingBody: SaveSaleVehicleLeasingBody | Nullish;
  currency: string;
  isReadOnly: boolean;
  onChange: (vehicleLeasingBody: SaveSaleVehicleLeasingBody) => void;
  onClose: () => void;
}

export function LeasingCellEditorDialog(props: LeasingCellEditorDialogProps) {
  const cellCoordinates = props.cellCoordinates;
  const vehicleLeasingBody = props.vehicleLeasingBody;

  if (isNil(cellCoordinates) || isNil(vehicleLeasingBody)) {
    return null;
  }

  return (
    <LeasingCellDialog
      key={`${cellCoordinates.term}-${cellCoordinates.annualMileage}`}
      isOpen
      term={cellCoordinates.term}
      annualMileage={cellCoordinates.annualMileage}
      cell={findLeasingCell(vehicleLeasingBody.rateMatrixCells, cellCoordinates)}
      currency={props.currency}
      isActive={isActiveLeasingCell(vehicleLeasingBody, cellCoordinates)}
      isReadOnly={props.isReadOnly}
      onClose={props.onClose}
      onSave={(cell, setActive) => {
        props.onChange(updateLeasingCell(vehicleLeasingBody, cell, setActive));
        props.onClose();
      }}
      onDelete={(cell) => {
        props.onChange(removeLeasingCell(vehicleLeasingBody, cell));
        props.onClose();
      }}
    />
  );
}
